import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=cc33ed66"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"
import style0 from "./Screenshots.vue?vue&type=style&index=0&id=cc33ed66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports